import xingliuLogo from '../assets/xingliu-logo-with-text.png';

export const Error = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-[#FAFAFA]">
      <img src={xingliuLogo} alt="xingliu-logo" className="w-[78px]" />
      <div className="text-[#1d2129] mt-4 text-base font-normal font-['PingFang SC'] leading-snug">
        抱歉，该项目不存在或已删除
      </div>
      <div className="w-[438px] h-[1px] bg-[#EDEDED]/60 my-4"></div>
      <div
        className="w-[116px] h-[38px] justify-end items-center gap-2 inline-flex"
        onClick={() => {
          window.location.href = '/projects';
        }}
      >
        <div className="px-4 py-2 bg-gradient-to-l from-[#1c2027] to-[#494f59] rounded justify-center items-center gap-2 flex overflow-hidden">
          <div className="text-white text-sm font-normal leading-snug">回到星流首页</div>
        </div>
      </div>
    </div>
  );
};
